import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState:any = {}

const topUpPricing = createSlice({
  name: 'topPricing',
  initialState,
  reducers: {
    setTopUpPricing(state,action:PayloadAction<any>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default topUpPricing.reducer;

// Actions
export const {setTopUpPricing} = topUpPricing.actions;

